// src/pages/home/discover/components/CategoryBySlug.jsx
import { Navigate, useParams } from "react-router-dom";

import {
  resolvePublicCategoryType,
} from "@/utils/homeCategoryRoute";

export default function CategoryBySlug() {
  const { search_type, search_item } = useParams();
  const canonicalType = resolvePublicCategoryType(search_type || "");
  const destinationType = canonicalType || search_type || "";
  const destinationItem = search_item || "";

  return <Navigate to={`/category/${destinationType}/${destinationItem}`} replace />;
}
